var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.26 146.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b1928e03-b672-4607-b7e9-bcd087974fdc{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bdd8b817-9e55-4498-bf38-2b34318e3c76",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b1928e03-b672-4607-b7e9-bcd087974fdc",
    d: "M116.63,7.76,68.37,36.49a3.66,3.66,0,0,0-1.78,3.14V80.77a3.65,3.65,0,0,0,1.83,3.16l32.75,18.91a3.44,3.44,0,0,1,0,6L50.22,138.22a3.69,3.69,0,0,1-1.83.49l-42.76,0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.29e84206.svg";
export { ForwardRef as ReactComponent };